import {Component, input}    from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {FoodRecordLogIntf}   from '@djsharkk/logr-types';
import {DialogEditBase}      from '../dialog-edit-base';

@Component({
			   selector   : 'app-dialog-edit-food',
			   imports: [
				   ReactiveFormsModule
			   ],
			   templateUrl: './dialog-edit-food.component.html',
			   styleUrl   : './dialog-edit-food.component.css'
		   })
export class DialogEditFoodComponent extends DialogEditBase<FoodRecordLogIntf> {
	rec = input.required<FoodRecordLogIntf>();
}
